import React from 'react'

type Urgency = 'High' | 'Medium' | 'Low'

export const RequisitionUrgencyDueDate = ({date, urgency}: {date?: string | null; urgency: Urgency}) => {
  const color = urgency === 'High' ? 'bg-danger' : urgency === 'Medium' ? 'bg-warning' : 'bg-success'
  const duration = urgency === 'Low' ? '90d' : urgency === 'Medium' ? '15d' : '0d'
  return <>
    <div className='mb-1'>{date || '-'}</div>
    <span className={`badge ${color} text-white`}>{urgency}</span>{' '}
    <small className='ms-1 text-muted'>{duration}</small>
  </>
}
